export default __webpack_public_path__ + "static/media/TasksLightActive.f514a527.svg";